<template>
    <q-page padding>
        <div class="q-display-1 q-mb-md text-secondary">
            <q-icon name="far fa-calendar-alt" class="q-mb-sm" /> {{ $t('events') }}
        </div>

        <q-tabs v-model="tab">
            <q-tab slot="title" name="basic_data" :label="$t('basic_data')" />
            <q-tab slot="title" name="qr_code" v-show="showTab" :label="$t('QR-Code')" />
            <q-tab slot="title" name="list_user" v-show="showTab" :label="$t('list_user')" />

            <q-tab-pane name="basic_data">
                <basic-data/>
            </q-tab-pane>

            <q-tab-pane name="qr_code">
                <qr-code/>
            </q-tab-pane>

            <q-tab-pane name="list_user">
                <participants/>
            </q-tab-pane>
        </q-tabs>
    </q-page>
</template>

<script>
import { mapGetters } from 'vuex'
import BasicData from 'components/admin/events/BasicData'
import QrCode from 'components/admin/events/QrCode'
import Participants from 'components/admin/events/Participants'

export default {
    i18nOptions: { namespaces: [ 'custom', 'common', 'admin', 'events'] },

    components: {
        'basic-data': BasicData,
        'participants': Participants,
        'qr-code': QrCode,
    },

    data() {
        return {
            tab: 'basic_data',
            id_event: 0
        }
    },

    computed: {
        showTab() {
            if (this.id_event != 0) return true
            else return false
        },
    },

    created() {
        this.id_event = this.$route.params.id

    },
    watch: {
        '$route': function (refreshPage) {
            this.id_event = this.$route.params.id
        }
    },
}
</script>

<style>

</style>


